<h2 mat-dialog-title *ngIf="!!data && !!data.deleteTitle" >{{ data.deleteTitle | translate }}</h2>
<h2 mat-dialog-title *ngIf="!data || !data.deleteTitle">{{ 'tasker.delete-dialog.title' | translate }}</h2>
<mat-dialog-content class="mat-typography">
    <div *ngIf="!!data && !!data.deleteQuestion">{{ data.deleteQuestion | translate }}</div>
    <div *ngIf="!data || !data.deleteQuestion">{{ 'tasker.delete-dialog.message' | translate }}</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{ 'tasker.common.cancel' | translate }}</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>{{ 'tasker.common.ok' | translate }}</button>
</mat-dialog-actions>